import { Grounds } from '@ifeng-fe/client_grounds';

export const pageId = 'vip_gift';

export const getGv = () => {
    return Grounds?.getDeviceInfo().getGv();
};

export const getAv = () => {
    return Grounds?.getDeviceInfo().getAv();
};

export const getGuid = () => {
    try {
        return Grounds?.getUserInfo()?.getGuid();
    } catch (error) {
        console.log('1');
    }
};

export const getUid = () => {
    return Grounds?.getDeviceInfo()?.getUid();
};

export const getDeviceId = () => {
    return Grounds?.getDeviceInfo()?.getDeviceId();
};

export const getProid = () => {
    return Grounds?.getDeviceInfo()?.getProid();
};

export const getOs = () => {
    return Grounds?.getDeviceInfo()?.getOs();
};

export const getDf = () => {
    return Grounds?.getDeviceInfo()?.getDf();
};

export const getVt = () => {
    return Grounds?.getDeviceInfo()?.getVt();
};

export const getScreen = () => {
    return Grounds?.getDeviceInfo()?.getScreen();
};

export const getPublishid = () => {
    return Grounds?.getDeviceInfo()?.getPublishid();
};

export const getToken = () => {
    return Grounds?.getUserInfo()?.getToken();
};

export const getClientParams = () => {
    return {
        gv: getGv() || '',
        av: getAv() || '',
        uid: getUid() || '',
        deviceid: getDeviceId() || '',
        proid: getProid() || '',
        os: getOs() || '',
        df: getDf() || '',
        vt: getVt() || '',
        loginid: getGuid() || '',
        screen: getScreen() || '',
        publishid: getPublishid() || '',
        token: getToken() || '',
        guid: getGuid() || '',
    };
};

export const pageHandler = ({ id }: { id: string }) => {
    try {
        // eslint-disable-next-line no-unused-expressions
        Grounds?.setShareVisibility(1);
        // eslint-disable-next-line no-unused-expressions
        Grounds?.pageStat({
            id,
        });
        // 判断是否是安卓系统，是的话去掉弹性滚动
        if (
            Grounds?.getDeviceInfo()
                ?.getOs()
                ?.match(/android/)
        ) {
            console.log('android');
        } else {
            // eslint-disable-next-line no-unused-expressions
            Grounds?.disableBounceEffect('close');
        }
    } catch (error) {
        console.error(error);
    }
};

export const isAndroid = () => {
    if (
        Grounds?.getDeviceInfo?.()
            ?.getOs?.()
            ?.match?.(/android/)
    ) {
        return true;
    }

    return false;
};

export const clickExpose = ({ type, id }: { type: string; id?: string }) => {
    console.log('发送统计', type, id);
    Grounds.actionStat({
        type,
        id,
    });
};

export const gotoNewPage = ({ type, url, ref }: dispatchParams) => {
    const urlNew = url ? (url.indexOf('?') > -1 ? `${url}&isFull=0` : `${url}?isFull=0`) : '';

    if (url) {
        Grounds.dispatch({
            link: { type, url: urlNew },
            pageLogParams: { ref },
        });
    }
};

export const goNative = ({ type, url, ref }: dispatchParams) => {
    Grounds.dispatch({
        link: { type, url },
        pageLogParams: { ref },
    });
};

export const updateVision = (isPc) => {
    // eslint-disable-next-line no-unused-expressions
    window?.grounds?.simpleToast('VIP已成功发放，您当前版本较低无法生效VIP权益，请升级至最新版App');
    setTimeout(() => {
        let href = 'https://dl.app.ifengcdn.com/ifengnews/202309/IfengNewsV7705_646_V7.70.5_9127.apk?apkname=凤凰新闻';

        if (isPc) {
            href = 'https://dl.app.ifengcdn.com/ifengnews/202309/IfengNewsV7705_646_V7.70.5_9126.apk?apkname=凤凰新闻';
        }
        // 升级版本
        if (isAndroid()) {
            window.location.href = href;
        } else {
            gotoNewPage({
                type: 'web',
                url: 'https://apps.apple.com/cn/app/%E5%87%A4%E5%87%B0%E6%96%B0%E9%97%BB-%E7%83%AD%E7%82%B9%E5%A4%B4%E6%9D%A1%E6%96%B0%E9%97%BB%E6%8A%A2%E5%85%88%E7%9C%8B/id395133418',
                ref: pageId,
            });
        }
    }, 1000);
};

export const gotoVipPage = (hasZige) => {
    if (hasZige) {
        // 跳转我的
        // eslint-disable-next-line no-unused-expressions
        window?.grounds?.simpleToast('免广特权已生效');
        setTimeout(() => {
            if (isAndroid()) {
                Grounds.dispatchByLink({
                    link: { navId: 'bottomNavMine', type: 'bottomNav', url: '' },
                });
            } else {
                goNative({ type: 'bottomNavMine', url: '' });
            }
        }, 3000);
    } else {
        // 跳转续费
        // eslint-disable-next-line no-unused-expressions
        window?.grounds?.simpleToast('您已经领取过了，好用您就续费吧');
        setTimeout(() => {
            goNative({ type: 'memberProductList', url: '' });
        }, 3000);
    }
};

export const afterGetVip = (hasZige: boolean, isPc: boolean): void => {
    const vision = getGv() || '';
    const [main, sub, min] = vision.split('.') || [];

    if (main && sub && min) {
        if (isAndroid()) {
            if (parseInt(main, 10) >= 7 && parseInt(sub, 10) >= 70 && parseInt(min, 10) >= 0) {
                gotoVipPage(hasZige);
            } else {
                updateVision(isPc);
            }
        } else if (parseInt(main, 10) >= 7 && parseInt(sub, 10) >= 69 && parseInt(min, 10) >= 0) {
            gotoVipPage(hasZige);
        } else {
            updateVision(isPc);
        }
    } else {
        updateVision(isPc);
    }
};

export const getQuery = (): Record<string, string> => {
    const ret: Record<string, string> = {};
    const seg = window.location.search.substring(1).split('&');
    const len = seg.length;

    let s;
    let i = 0;

    for (; i < len; i++) {
        if (!seg[i]) {
            continue;
        }
        s = seg[i].split('=');
        ret[s[0]] = s[1];
    }

    return ret;
};
